<div class="b2a-activityContainer">
  <div header class="b2a-activityContainer__header">
    {{ 'ACTIVITY.title' | translate }}
    <app-chips-list-notResponsive class="tab-indicator">
      <app-chip-notResponsive (select)="toggleDay()" selected="true">{{ 'ACTIVITY.day' | translate }}</app-chip-notResponsive>
      <app-chip-notResponsive (select)="toggleWeek()">{{ 'ACTIVITY.week' | translate }}</app-chip-notResponsive>
      <app-chip-notResponsive (select)="toggleMonth()">{{ 'ACTIVITY.month' | translate }}</app-chip-notResponsive>
    </app-chips-list-notResponsive>
  </div>

  <div class="b2a-activityContainer__inner">
    <div class="chart-container">
      <div *ngIf="showWeek" class="progress-bar-container">
        <ngx-charts-bar-horizontal
          #chart
          [scheme]="colorScheme"
          [results]="data"
          [xAxis]="true"
          [yAxis]="true"
          [legend]="false"
          [activeEntries]="[data[data.length - 1]]"
          [showXAxisLabel]="false"
          [showYAxisLabel]="false"
          [yAxisTickFormatting]="yAxisFormatting"
          [xScaleMax]="6"
          [barPadding]="16"
          [animations]="true"
          [showGridLines]="false"
          [roundEdges]="true"
  
        >
        </ngx-charts-bar-horizontal>

        <div *ngIf="weeklyProgress <= 2" class="text-below-progress">{{ 'ACTIVITY.progress.week_low' | translate }}</div>
        <div *ngIf="weeklyProgress <= 2" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.week_low_sub' | translate: { count: weeklyProgress } }}
        </div>
        <div *ngIf="weeklyProgress > 2 && weeklyProgress < 6" class="text-below-progress">{{ 'ACTIVITY.progress.week_medium' | translate }}</div>
        <div *ngIf="weeklyProgress > 2 && weeklyProgress < 6" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.week_medium_sub' | translate: { count: weeklyProgress } }}
        </div>
        <div *ngIf="weeklyProgress == 6" class="text-below-progress">{{ 'ACTIVITY.progress.week_complete' | translate }}</div>
        <div *ngIf="weeklyProgress == 6" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.week_complete_sub' | translate }}
        </div>
      </div>

      <div *ngIf="showDay" class="progress-bar-container">
        <daily-progress-bar [progress]="mapToPercentage()" [progressCount]="todayProgress"></daily-progress-bar>
        <div *ngIf="todayProgress <= 2" class="text-below-progress">{{ 'ACTIVITY.progress.low' | translate }}</div>
        <div *ngIf="todayProgress <= 2" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.low_sub' | translate: { remaining: (6 - todayProgress) } }}
        </div>
        <div *ngIf="todayProgress > 2 && todayProgress < 6" class="text-below-progress">{{ 'ACTIVITY.progress.medium' | translate }}</div>
        <div *ngIf="todayProgress > 2 && todayProgress < 6" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.medium_sub' | translate: { remaining: (6 - todayProgress) } }}
        </div>
        <div *ngIf="todayProgress == 6" class="text-below-progress">{{ 'ACTIVITY.progress.complete' | translate }}</div>
        <div *ngIf="todayProgress == 6" class="subtext-below-progress">
          {{ 'ACTIVITY.progress.complete_sub' | translate }}
        </div>
      </div>

      <div *ngIf="showMonth">
        <calendar-progress></calendar-progress>
        
        
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/activity-achievement.component.html